import { DetermineTextColor } from "../utils/DetermineTextColor";
import { Div2Floor } from "../utils/Div2Floor";
import {
  enumButtonLabelPosition,
  enumDragDropType,
  enumElementBorderStyle,
  enumElementDrawStates,
  enumPadBorderType,
  kCheckEnabled,
  kSquareCheckIcon,
  kSquareIcon
} from "../constants";
import { QButton } from "./QButton";
import { QTextEdit } from "./QTextEdit";
import { shadeColor } from "../utils/shadeColor";
import { TruncateText } from "../utils/TruncateText";
import { uFramelessPanelColor } from "../whitelabel/brand";
import { Globals } from "./Globals";
import { MeasureTextHeight } from "../utils/MeasureTextHeight";
import { SetCtxFont } from "../utils/SetCtxFont";

export class QBasicButton extends QButton {
  constructor() {
    super();
    this.fCmdCode = "";
    this.fFontString = "12px Arial";
    this.fNoBorder = false;
    this.fLabelInset = 0;
    this.fRowIndex = -1;
    this.fDoBoldAnimation = false;
    this.fDropType = enumDragDropType.none;
    this.fBorderColor = null;
    this.fDrawPad = true;
    this.fAdditionalCmdParameters = null;
    this.fRenderHighlightSelectionBeneathText = true;
    this.fRenderDisableFill = true;
  }

  InitBasicButton(parent, label, cmdCode, x, y, buttonWidth, buttonHeight) {
    this.fParent = parent;
    this.fUIColors = parent.fWSMgr.GetUIColors();
    this.SetLabel(label);
    this.AutoSize();
    if (buttonWidth) {
      this.fWidth = buttonWidth;
    }
    if (buttonHeight) {
      this.fHeight = buttonHeight;
    }
    this.PositionElement(x, y);
    this.SetCmdCode(cmdCode);
    var backGroundColor = uFramelessPanelColor; //shadeColor(uFramelessPanelColor, -10); //this.fUIColors.GetButtonFillColor();
    this.SetBorderStyle(enumElementBorderStyle.roundBorder);
    this.SetBorderThickness(0);
    this.SetBorderRadius(2);
    this.SetFillColor(backGroundColor);
    this.fTxtFillStyle = DetermineTextColor(backGroundColor);
    var borderColor = shadeColor(backGroundColor, -35);
    this.SetBorderColor(borderColor);
    parent.PushElement(this);
  }

  GetParentPanel() {
    return this.fParent;
  }

  GetCursor() {
    return "pointer";
  }

  SetLabelLeft() {
    this.fLabelPosition = enumButtonLabelPosition.left;
  }

  StartInteractWithElement(canvasX, canvasY, panelX, panelY, shiftDown) {
    this.fParent.fBackgroundPanel.StartDrag(this, canvasX, canvasY, shiftDown);
    return true;
  }

  GetRealContent() {
    //Used to simplify true/false checks. Semi-dirty...
    return !(this.fLabel == kCheckEnabled);
  }

  GetListID() {
    return this.fListRef.GetListID();
  }

  GetListElementID() {
    return this.fListElementID;
  }

  InteractWithElement(x, y) {
    if (this.fControlMode == /*enumFMElementControlMode.textedit*/ false)
      return QTextEdit.prototype.InteractWithElement.call(this, x, y);
    else if (this.fControlMode !== /*enumFMElementControlMode.none*/ false) {
      var sx = this.fParentPanel.GetPositionX();
      var sy = this.fParentPanel.GetPositionY();

      var deltaX = x + sx - this.fStartX;
      var deltaY = y + sy - this.fStartY;

      this.fParentPanel.PositionPanel(sx + deltaX, sy + deltaY);

      this.fStartX = x + sx;
      this.fStartY = y + sy;
    }
  }

  SetParentDragInfo(startX, startY, multiMove) {
    this.fStartX = startX;
    this.fStartY = startY;

    this.fOrigX = startX;
    this.fOrigY = startY;
    this.fMultiMove = multiMove;
  }

  ShrinkToFit(height) {
    var tWidth = this.GetWidth();
    var autoWidth = 14 + tWidth + 2;

    this.fParentPanel.SizePanel(autoWidth, height);
    this.SizeElement(autoWidth, height);
  }

  NoDrag() {
    if (this.fStartX == this.fOrigX && this.fStartY == this.fOrigY) return true;
    else return false;
  }

  ExecuteCommand(cmdCode) {
    this.fParent.ExecuteCommand(cmdCode);
  }

  DoRenderContent(drawBuffer) {}

  DoRenderElement(drawBuffer) {
    var drawState = this.GetDrawState();
    var drawAsSelected = this.fIsActive || this.fSelected;

    switch (drawState) {
      case enumElementDrawStates.Std:
        if (this.fDrawPad) {
          this.DrawPad(drawBuffer, false, drawAsSelected, false, false);
        }
        break;
      case enumElementDrawStates.Hover:
        this.DrawPad(drawBuffer, false, drawAsSelected, true, false);
        break;
      case enumElementDrawStates.MouseDown:
        this.DrawPad(drawBuffer, true, drawAsSelected, false, false);
        break;
      case enumElementDrawStates.Disabled:
        this.DrawPad(drawBuffer, false, false, false, true);
        break;
    }

    this.fTextAlign = "left";
    this.DoRenderContent(drawBuffer);
    this.DrawLabel(drawBuffer);
    this.DoRenderDropIndicators(drawBuffer);
  }

  DoRenderDropIndicators(drawBuffer) {
    var dI = this.fDropType;
    if (dI === enumDragDropType.none) return;

    var ctx = drawBuffer.getContext("2d");

    var sx = this.fHorzOffset + 0.5;
    var sy = this.fVertOffset + 0.5;
    var ex = this.fHorzOffset + this.fWidth - 0.5;
    var ey = this.fVertOffset + this.fHeight - 0.5;

    ctx.strokeStyle = "#000000";

    var t0x, t0y, t1x, t1y, t2x, t2y;
    var doDrawTri = true;
    var doDrawUnderline = true;

    t0x = sx + Math.floor((ex - sx) / 2);
    t1x = t0x + 5;
    t2x = t0x - 5;
    if (dI === enumDragDropType.above) {
      //above the box
      t0y = sy - 8;
      t1y = t0y + 5;
      t2y = t0y + 5;
    } else if (dI === enumDragDropType.below) {
      // Below the box
      t0y = ey + 8;
      t1y = t0y - 5;
      t2y = t0y - 5;
    }

    if (doDrawTri) {
      ctx.save();
      ctx.fillStyle = Globals._themeMode.text.alt;
      ctx.lineWidth = 2;
      ctx.lineJoin = "miter";

      ctx.beginPath();
      ctx.moveTo(t0x, t0y);
      ctx.lineTo(t1x, t1y);
      ctx.lineTo(t2x, t2y);
      ctx.lineTo(t0x, t0y);
      ctx.closePath();

      ctx.stroke();
      ctx.fill();

      ctx.restore();
    }
    if (doDrawUnderline) {
      ctx.save();
      var underlineThickness = 2;
      ctx.lineWidth = underlineThickness;
      ctx.strokeStyle = Globals._themeMode.text.alt;
      var startX = sx;
      var endX = ex;
      var yPos = t2y;

      ctx.beginPath();
      ctx.moveTo(startX, yPos);
      ctx.lineTo(endX, yPos);
      ctx.stroke();
      ctx.closePath();
      ctx.restore();
    }
  }

  AutoSize() {
    this.fMinW = 22;
    this.fMinH = 20;
    var sizeW = this.fMinW ? this.fMinW : 0;
    var sizeH = this.fMinH ? this.fMinW : 0;
    var l = this.fLabel;

    if (l != "") {
      var labelHeight = MeasureTextHeight(this.fFontString, 18) * 2;
      var labelLen = this.MeasureLabel() + 20;
      if (this.fIcon) {
        var buffer = this.fDrawPad ? 5 : 0;
        labelHeight = MeasureTextHeight(this.fFontString, 18) + buffer * 2;
        labelLen = this.MeasureLabel() + buffer * 2;
      }

      if (labelLen > sizeW) sizeW = labelLen;
      if (labelHeight > sizeH) sizeH = labelHeight;
    }
    this.SizeElement(sizeW, sizeH);
  }

  DrawPad(drawBuffer, mouseDown, selected, hover, disabled) {
    var ctx = drawBuffer.getContext("2d");
    var r2d = Math.PI / 180;
    ctx.save();

    var fillColor = this.fFillColor;

    var strokeStyle = this.fBorderColor ? this.fBorderColor : shadeColor(fillColor, -35);
    ctx.strokeStyle = strokeStyle;
    ctx.lineWidth = this.fBorderThickness;

    var dropType = this.fDropType;
    var dragOver = dropType === enumDragDropType.above || dropType === enumDragDropType.below;
    if (dragOver) {
      fillColor = shadeColor(fillColor, -15);
    }
    ctx.fillStyle = fillColor;

    var r = 0;
    var sx = this.fHorzOffset + 1;
    var sy = this.fVertOffset + 1;
    var ex = this.fHorzOffset + this.fWidth - 1;
    var ey = this.fVertOffset + this.fHeight - 1;

    var doClip = false;
    var bt = this.fPadBorderType;
    var borderStyle = this.GetBorderStyle();
    if (borderStyle === enumElementBorderStyle.roundBorder) bt = enumPadBorderType.roundBorder;

    switch (bt) {
      case enumPadBorderType.fullBorder:
        ctx.beginPath();
        ctx.moveTo(sx + r, sy);
        ctx.lineTo(ex - r, sy);
        ctx.arc(ex - r, sy + r, r, r2d * 270, r2d * 360, false);
        ctx.lineTo(ex, ey - r);
        ctx.arc(ex - r, ey - r, r, r2d * 0, r2d * 90, false);
        ctx.lineTo(sx + r, ey);
        ctx.arc(sx + r, ey - r, r, r2d * 90, r2d * 180, false);
        ctx.lineTo(sx, sy + r);
        ctx.arc(sx + r, sy + r, r, r2d * 180, r2d * 270, false);
        ctx.closePath();
        break;
      case enumPadBorderType.leftBorder:
        ctx.beginPath();
        ctx.moveTo(ex + 0.5, sy);
        ctx.lineTo(sx + r, sy);
        ctx.arc(sx + r, sy + r, r, r2d * 270, r2d * 180, true);
        ctx.lineTo(sx, ey - r);
        ctx.arc(sx + r, ey - r, r, r2d * 180, r2d * 90, true);
        ctx.lineTo(ex + 0.5, ey);
        ctx.stroke();
        ctx.closePath();
        break;
      case enumPadBorderType.rightBorder:
        ctx.beginPath();
        ctx.moveTo(sx - 0.5, sy);
        ctx.lineTo(ex - r, sy);
        ctx.arc(ex - r, sy + r, r, r2d * 270, r2d * 360, false);
        ctx.lineTo(ex, ey - r);
        ctx.arc(ex - r, ey - r, r, r2d * 0, r2d * 90, false);
        ctx.lineTo(sx - 0.5, ey);
        ctx.stroke();
        ctx.closePath();
        break;
      case enumPadBorderType.middleBorder:
        ctx.beginPath();
        ctx.moveTo(sx - 0.5, sy);
        ctx.lineTo(ex + 0.5, sy);
        ctx.stroke();
        ctx.moveTo(sx - 0.5, ey);
        ctx.lineTo(ex + 0.5, ey);
        ctx.stroke();
        ctx.lineTo(ex + 0.5, sy);
        ctx.lineTo(sx - 0.5, sy);
        ctx.closePath();
        break;
      case enumPadBorderType.roundBorder:
        doClip = true;
        break;
      default:
        break;
    }
    switch (true) {
      case mouseDown:
        ctx.fillStyle = shadeColor(fillColor, -15);
        break;
      case selected:
        ctx.lineWidth = 4;
        ctx.fillStyle = shadeColor(fillColor, -5);
        break;
      case hover:
        var gradient = ctx.createLinearGradient(0, sy - 100, 0, ey);
        gradient.addColorStop(0, "#EEEEEE");
        gradient.addColorStop(1, shadeColor(fillColor, 10));
        if (this.fHighlightColor) gradient = this.fHighlightColor;
        ctx.fillStyle = gradient;
        break;
      case disabled:
        if (this.fUseThemeColor) {
          var gradient = ctx.createLinearGradient(0, sy - 200, 0, ey);
          var disabledColor = shadeColor("#AFAFAF", -40);
          strokeStyle = "#AFAFAF";
          gradient.addColorStop(0, disabledColor);
          gradient.addColorStop(1, fillColor);
          ctx.fillStyle = gradient;
        } else if (this.fRenderDisableFill) {
          strokeStyle = Globals._themeMode.text.disabled;
          ctx.fillStyle = Globals._themeMode.button.disabled;
        }
        break;
      default:
        var gradient = ctx.createLinearGradient(0, sy - 200, 0, ey);
        gradient.addColorStop(0, fillColor);
        gradient.addColorStop(1, fillColor);
        ctx.fillStyle = gradient;
    }

    ctx.strokeStyle = strokeStyle;

    if (this.fClippedRegion) {
      ctx.fill(this.fClippedRegion);
      if (this.fBorderThickness > 0) ctx.stroke(this.fClippedRegion);
    } else {
      if (this.fCurDrawState === enumElementDrawStates.Std) ctx.fillStyle = fillColor;
      if (this.fPadBorderType != enumPadBorderType.fullBorder) {
        ctx.beginPath();
        ctx.moveTo(sx + r, sy);
        ctx.lineTo(ex - r, sy);
        ctx.arc(ex - r, sy + r, r, r2d * 270, r2d * 360, false);
        ctx.lineTo(ex, ey - r);
        ctx.arc(ex - r, ey - r, r, r2d * 0, r2d * 90, false);
        ctx.lineTo(sx + r, ey);
        ctx.arc(sx + r, ey - r, r, r2d * 90, r2d * 180, false);
        ctx.lineTo(sx, sy + r);
        ctx.arc(sx + r, sy + r, r, r2d * 180, r2d * 270, false);
        ctx.closePath();

        ctx.fill();
        if (this.fCurDrawState != enumElementDrawStates.Std) {
          ctx.stroke();
        }
      } else {
        ctx.fill();
        if (this.fBorderThickness > 0) ctx.stroke();
      }
    }

    ctx.shadowBlur = 0;
    ctx.globalAlpha = 1;
    ctx.restore();
  }

  DrawLabel(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    ctx.save();

    var drawState = this.GetDrawState();
    var txtHOffset = Div2Floor(this.fWidth);

    var txtFillStyle =
      this.fTxtFillStyle != null ? this.fTxtFillStyle : DetermineTextColor(this.fFillColor);

    var dI = this.fDropType;
    if (dI !== enumDragDropType.none || drawState === enumElementDrawStates.Disabled)
      ctx.globalAlpha = 0.7;

    switch (drawState) {
      case enumElementDrawStates.Disabled:
        txtFillStyle = Globals._themeMode.text.disabled;
        break;
    }

    ctx.fillStyle = txtFillStyle;
    var fontString = this.fFontString != null ? this.fFontString : "11px Arial";

    ctx.textAlign = "center";
    ctx.textBaseline = "bottom";

    var txt = this.fLabel;
    var labelText = TruncateText(txt, fontString, this.GetWidth());
    var xPos, yPos;
    switch (this.fLabelPosition) {
      case enumButtonLabelPosition.below:
        xPos = this.fHorzOffset + txtHOffset;
        yPos = this.fVertOffset + this.fHeight - 4;
        break;
      case enumButtonLabelPosition.center:
        ctx.textBaseline = "middle";
        xPos = this.fHorzOffset + txtHOffset;
        yPos = this.fVertOffset + this.fHeight / 2;
        break;
      case enumButtonLabelPosition.left:
        var labelW = this.MeasureLabel();
        var txtHIndent = 6;
        ctx.textBaseline = "middle";
        xPos = this.fHorzOffset + labelW / 2 + txtHIndent + this.fLabelInset;
        yPos = this.fVertOffset + this.fHeight / 2;
        break;
    }
    SetCtxFont(ctx, fontString);
    ctx.fillText(labelText, xPos, yPos, this.GetWidth());

    // TODO: handle this better
    if (labelText === kSquareIcon || labelText === kSquareCheckIcon) {
      ctx.strokeStyle = this.fIconColor ? this.fIconColor : "black";
      ctx.strokeText(labelText, xPos, yPos, this.GetWidth());
    }

    ctx.shadowBlur = 0;
    ctx.globalAlpha = 1;
    ctx.restore();
  }
}
